import React from 'react';

const GoldSnapshotFormModal = React.lazy(() => import('../components/FormModal'));
const goldSnapshotModalRegistry = {
    company_goldSnapshotId: GoldSnapshotFormModal
};
export default goldSnapshotModalRegistry;
